export default "__VITE_ASSET__EamQzq6X__"